import React from "react";
import styled from "styled-components";
import { ALTO_GREY } from "../../../constants/colors";

export const DashboardIframe = styled.iframe`
  border: none;
  box-shadow: 0 0 5px 0 ${ALTO_GREY};
  display: none;
`;
